import useThrottleClick from 'hooks/useThrottleClick';
import { openStore, trackEvent } from 'utils';
import { TGame } from 'types';

function useThrottleInstallGameClick(game?: TGame | null) {
  const installCallback = async () => {
    if (game) {
      await trackEvent(game.trackURL.impression);
      await trackEvent(game.trackURL.click);

      openStore(game.id);
    }
  };

  return useThrottleClick(undefined, undefined, installCallback, 3000);
}

export default useThrottleInstallGameClick;
